import { useLocation, useNavigate } from "react-router";

type UseUrlSyncedModalReturn = {
  open: boolean;
  onOpen: () => void;
  onClose: () => void;
};

const useUrlSyncedModal = (
  paramKey: string,
  paramValue: string,
): UseUrlSyncedModalReturn => {
  const location = useLocation();
  const navigate = useNavigate();

  const urlParams = new URLSearchParams(location.search);
  const param = urlParams.get(paramKey);
  const open = param === paramValue;

  const onOpen = () => {
    const newUrlParams = new URLSearchParams(location.search);
    newUrlParams.set(paramKey, paramValue);
    navigate(`${location.pathname}?${newUrlParams.toString()}`);
  };

  const onClose = () => {
    const newUrlParams = new URLSearchParams(location.search);
    newUrlParams.delete(paramKey);
    const newSearch = newUrlParams.toString();
    navigate(`${location.pathname}${newSearch ? `?${newSearch}` : ""}`, {
      replace: true,
    });
  };

  return {
    open,
    onOpen,
    onClose,
  };
};

export default useUrlSyncedModal;
